import Control from "../../../../../common/Controls/Control";
import useRCPROQuestion from "./useRCPROQuestion";

const RCPROAutreService = ({ company }) => {
  const { updateRcproData, onBlur, errors, inputsConfig } = useRCPROQuestion({
    company,
  });
  return (
    <div>
      <Control
        label={inputsConfig.autresServicesNatureServices.label}
        type="checkBtnList"
        name="autresServicesNatureServices"
        value={company.RCPRO.autresServicesNatureServices}
        change={updateRcproData}
        error={errors}
        labelClassname="w-100"
        inputGroupStyle={{ width: "100%" }}
        btnInline
        datas={inputsConfig.autresServicesNatureServices.datas}
        dataIndex="id"
        dataLabel="name"
        onBlur={onBlur}
        required
        info={<>Plusieurs réponses possibles.</>}
      />
      {company.RCPRO.autresServicesNatureServices.includes(4) && (
        <Control
          label={inputsConfig.autresServicesAutreNatureServices.label}
          type="text"
          name="autresServicesAutreNatureServices"
          value={company.RCPRO.autresServicesAutreNatureServices}
          change={updateRcproData}
          error={errors}
          labelClassname="w-100"
          inputGroupStyle={{ width: "100%" }}
          onBlur={onBlur}
          required
        />
      )}
      <Control
        label={inputsConfig.autresServicesDeplacementsFrequents.label}
        type="btnList"
        name="autresServicesDeplacementsFrequents"
        value={company.RCPRO.autresServicesDeplacementsFrequents}
        change={updateRcproData}
        error={errors}
        labelClassname="w-100"
        inputGroupStyle={{ width: "100%" }}
        btnInline
        datas={inputsConfig.autresServicesDeplacementsFrequents.datas}
        dataIndex="id"
        dataLabel="name"
        onBlur={onBlur}
        required
      />
      <Control
        label={inputsConfig.autresServicesProfessionReglementee.label}
        type="btnList"
        name="autresServicesProfessionReglementee"
        value={company.RCPRO.autresServicesProfessionReglementee}
        change={updateRcproData}
        error={errors}
        labelClassname="w-100"
        inputGroupStyle={{ width: "100%" }}
        btnInline
        datas={inputsConfig.autresServicesProfessionReglementee.datas}
        dataIndex="id"
        dataLabel="name"
        onBlur={onBlur}
        required
      />
    </div>
  );
};

export default RCPROAutreService;
